module.exports = __webpack_public_path__ + "img/header-3.5340ba7.jpg";